import { Spin } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { BtlBaseForm } from 'pages/BtlApplicationFormPage/BtlBaseForm';
import { useOoCaseFinancingForm } from './useOoCaseFinancingForm';

interface CaseFinancingPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
}

export function CaseFinancingPage({ case: caseData, isCaseLoading }: CaseFinancingPageProps) {
  const form = useOoCaseFinancingForm({ caseData, isCaseLoading });

  if (form.isLoading) {
    return <Spin size='large' />;
  }

  return <BtlBaseForm {...form.formProps} />;
}
